import { useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import config from "../config";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faExclamationTriangle, faSpinner } from "@fortawesome/free-solid-svg-icons";

// Reached from a link in the subscription-cancelled email — deliberately no
// login required, since whoever clicks it may not have an active session in
// that browser. `u` identifies the account server-side (never trust a
// client-typed email for this); this page itself asks for nothing but the
// reason.
const CancelledFeedback = () => {
    const [searchParams] = useSearchParams();
    const userId = searchParams.get('u') || '';

    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError(false);
        setLoading(true);

        try {
            await axios.post(`${config.backendUrl}users/feedback/cancellation`, {
                userId,
                message,
            }, {
                headers: { 'Content-Type': 'application/json' }
            });
            setSubmitted(true);
        } catch {
            setError(true);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="web-page">
            <div className="page-shell page-shell--narrow review-page">
                <header className="page-header review-header">
                    <h1 className="page-title">Sorry to see you go</h1>
                    <p className="page-lead">
                        Your subscription is canceled. Mind telling us why you left? It genuinely helps us improve — this takes ten seconds.
                    </p>
                </header>

                <div className="panel review-card">
                    {submitted ? (
                        <div className="form-message form-message--success" role="status">
                            <FontAwesomeIcon icon={faCheckCircle} />
                            Thanks for the feedback — we read every message.
                        </div>
                    ) : (
                        <form className="review-form" onSubmit={handleSubmit}>
                            <div className="form-field">
                                <label className="form-label" htmlFor="cancel-reason-input">What made you cancel?</label>
                                <textarea
                                    required
                                    id="cancel-reason-input"
                                    className="input form-textarea"
                                    rows={5}
                                    placeholder="Too expensive, missing a feature, didn't find sponsors fast enough..."
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                />
                            </div>

                            <div className="form-actions">
                                <button
                                    type="submit"
                                    className="btn btn-primary btn-full"
                                    disabled={loading}
                                >
                                    {loading ? (
                                        <>
                                            <FontAwesomeIcon icon={faSpinner} spin />
                                            {' '}Sending…
                                        </>
                                    ) : (
                                        'Send feedback'
                                    )}
                                </button>
                                <Link to="/" className="form-message" style={{ justifyContent: 'center', textDecoration: 'none' }}>
                                    No thanks, skip
                                </Link>
                                {error && (
                                    <div className="form-message form-message--error" role="alert">
                                        <FontAwesomeIcon icon={faExclamationTriangle} />
                                        Something went wrong. Please try again.
                                    </div>
                                )}
                            </div>
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CancelledFeedback;
